import { Star } from 'lucide-react';
import { Reveal, Chapter } from './motion';

const REVIEWS = [
  {
    name: 'Karen M.',
    location: 'Stanfield, NC',
    text: 'Our AC quit in the middle of July and Holbrooks had a technician out the same day. He explained everything, fixed the issue, and the price was fair. You can tell they have been doing this a long time.',
    service: 'AC Repair',
  },
  {
    name: 'David R.',
    location: 'Locust, NC',
    text: 'They replaced our old heat pump with a new American Standard system. The install crew was clean, on time, and walked us through the new thermostat. The house has never felt more comfortable.',
    service: 'HVAC Replacement',
  },
  {
    name: 'Lisa T.',
    location: 'Concord, NC',
    text: 'We used B.E. Holbrooks for a water line repair that needed excavation. One company handled the digging and the plumbing, which saved us days of hassle. Professional from start to finish.',
    service: 'Plumbing & Excavation',
  },
];

export default function Reviews() {
  return (
    <section className="bg-brand-soft/60 py-16 lg:py-24" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal>
          <Chapter num="07" label="Local Proof" />
          <div className="mt-4 flex flex-wrap items-end justify-between gap-4">
            <h2 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              What Your Neighbors Say
            </h2>
            <div className="flex items-center gap-2" data-testid="reviews-rating-badge">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-amberwarm text-amberwarm" data-testid={`review-star-${i}`} />
                ))}
              </div>
              <span className="font-mono text-sm font-bold text-navy">5.0 Local Rating</span>
            </div>
          </div>
        </Reveal>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12}>
              <figure className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1.5 hover:shadow-lg" data-testid={`review-card-${i}`}>
                <div className="mb-3 flex">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-amberwarm text-amberwarm" />
                  ))}
                </div>
                <blockquote className="flex-1 text-sm leading-relaxed text-slate-600">“{r.text}”</blockquote>
                <figcaption className="mt-5 border-t border-slate-100 pt-4">
                  <p className="font-display text-sm font-bold text-navy">{r.name} <span className="font-body font-normal text-slate-400">· {r.location}</span></p>
                  <p className="mt-0.5 font-mono text-xs uppercase tracking-wider text-brand">{r.service}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <p className="mt-6 text-xs text-slate-400">Sample reviews shown as placeholders — replace with live Google reviews at launch.</p>
      </div>
    </section>
  );
}
